// src/components/common/EmptyState/EmptyState.jsx
import React from 'react';
import styles from './EmptyState.module.css';

const EmptyState = ({
    title = 'Nenhum registro encontrado',
    message = 'Comece adicionando um novo registro.',
    actionText,
    onAction,
}) => {
    return (
        <div className={styles.emptyState}>
            <div className={styles.emptyTitle}>{title}</div>
            <p className={styles.emptyMessage}>{message}</p>
            {actionText && onAction && (
                <button onClick={onAction} className={styles.actionButton}>
                    {actionText}
                </button>
            )}
        </div>
    );
};

export default EmptyState;